export enum GridLayout {
    ONESQUARE = 'onesquare',
    FOURSQUARE = 'foursquares',
    NINESQUARE = 'ninesquares'
}
